import DecoratedNumber from 'components/decorated-number'
import type { UseAssetFormLayout } from '../types'
import { EAssetType } from 'findef'

export const ROILayout = (): UseAssetFormLayout => ({
  key: 'investment-ROI',
  needs: ['invested.type', 'asset.ledger.sharePrice.type'],
  component: () => {
    return (props) => {
      return (
        <div class="flex flex-col items-center justify-center w-full border border-gray-300 bg-gray-100 py-1 px-3 max-h-[42px]">
          <div class="text-[10px] text-gray-500">My ROI</div>
          <div class="flex flex-row items-center gap-1">
            <div class="text-sm font-medium max-h-[42px]">
              <DecoratedNumber
                tween={true}
                unit="percent"
                valueClass="font-medium text-sm"
                unitClass="font-medium text-sm"
                iconSize="0.75rem"
                formatOptions={{
                  american: true,
                  maxDecimals: 2,
                  minDecimals: 2
                }}
                arrow
                signs={['+', '-']}
                value={props.state.value.asset.type === EAssetType.CASH ? props.data.value.ROICash : props.data.value.ROI}
              />
            </div>
          </div>
        </div>
      )
    }
  }
})
